<template>
    <div class="create-visit-form__select">
        <button 
            class="list-toggle-button"
            type="button" 
            @click="show = !show" 
            :id="field.id + '-button'"
            :aria-controls="field.id" 
            :aria-expanded="show ? 'true' : 'false'"
            :disabled="field.options.length == 0"
        >
            <span v-if="!selected || selectedIndex == -1">{{ field.label }}</span>
            <span v-else>{{ field.options[selectedIndex].label }}</span>
            <div class="list-toggle-icon">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </button>
        <div class="radio-list" v-show="show" :id="field.id">
            <fieldset>
                <legend class="show-for-sr">{{ field.label }}</legend>
                <label v-for="option in field.options" :key="option.value">
                    <input type="radio" :name="field.name" :value="option.value" class="show-for-sr" v-model="selected" :required="field.required">
                    <span></span>
                    {{ option.label }}
                </label>
            </fieldset>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SelectField',
    props: ['field'],
    data() {
        return {
            show: false,
            selected: '',
            selectedIndex: -1,
        }
    },
    watch: {
        selected(newVal) {
            this.show = false;
            this.selectedIndex = this.field.options.findIndex(o => o.value === newVal);
            if(this.field.name === 'operation') {
                this.$store.commit('setOperation', newVal);
                this.$store.dispatch('getCategories');
            }
        }
    },
    mounted() {
        const events = ['click', 'keyup'];
        const popupList = this.$el.querySelector(`#${this.field.id}`);
        const toggleButton = this.$el.querySelector(`#${this.field.id}-button`);
        if (toggleButton && popupList) {
            events.forEach((evt) => {
                document.addEventListener(evt, (e) => {
                    if (e.type === 'keyup' && e.key !== 'Tab') {
                        return;
                    }
                    if (e.target !== popupList
                        && !popupList.contains(e.target)
                        && e.target !== toggleButton
                        && !toggleButton.contains(e.target)) {
                        this.show = false;
                    }
                });
            });
        }

        document.querySelector('.create-visit-form__form').addEventListener('reset', () => {
            this.selected = '';
            this.selectedIndex = -1;
        })
    }
}
</script>